
import { useQuery } from "@tanstack/react-query";
import { supportChatServices } from "../services/supportChat.service";

export const useSupportChats = () => {
  return useQuery({
    queryKey: ["supportChats"],
    queryFn: supportChatServices.getChats,
  });
};